export enum HawkerCommissaryAssignmentHistoryForm {
  ShowingTopEvents = 'GVzE',
}
